<template>
    <div class="w100 bgGrey">
        <article class="wContent center">
            <div class="bgWhite" v-loading="registarLoading" style="padding: 60px 0;">
                <!-- 注册弹框 start -->
                <div style="width: 800px; border: 1px solid #ddd" class="center radius p20">
                    
                    <el-row>
                        <el-col :span="10">
                            <div class="login-code textCenter" style="height: 325px; padding-top: 80px;">
                                <img src="../../assets/images/login_code.png" alt="" srcset="">
                                <p>扫一扫下载唐宋钢铁APP<br>钢铁行情一手掌握</p>
                            </div>
                        </el-col>
                        <el-col :span="14">
                            <div class="login-form">
                                <p class="fontRed font14" style="margin-top: -10px; margin-bottom: 20px;">*若无手机号，请联系客服(400-6565-958)</p>
                                <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
                                    <el-form-item prop="telephone">
                                        <el-input clearable v-model="registerForm.telephone" auto-complete="off" placeholder="请输入手机号" style="margin-bottom: 10px;" class="w100"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="newPwd">
                                        <el-input clearable type="password" v-model="registerForm.newPwd" auto-complete="off" placeholder="请设置新密码" style="margin-bottom: 10px;" class="w100"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="code">
                                        <el-input clearable v-model="registerForm.code" auto-complete="off" placeholder="请输入验证码" class="w100">
                                            <template slot="append">
                                                <span v-show="sendCodeTime == 0" @click="sendCode" class="pointer">发送验证码</span>
                                                <span v-show="sendCodeTime != 0">({{ sendCodeTime }})秒后重新发送</span>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                                <div slot="footer" class="dialog-footer" style="margin-top: 15px;">
                                    <el-button class="bgRed w100 fontWhite" @click="register('registerForm')" size="medium">确 认</el-button>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <!-- 注册弹框 end -->
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import $ from 'jquery'
import { mw_validate, baseUrl } from '../../assets/js/common'

export default {
    name: 'ChangePwd',
    components: { },
    data () {
        return {
            registarLoading: false,
            sendCodeTime: 0, // 计时器
            registerForm: { // 注册的所有信息
                telephone: '', // 手机号
                newPwd: '', // 密码
                code: '' // 验证码
            },
            registerRules: {
                telephone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                newPwd: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 16, message: '请设置6-16位密码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
        }
    },
    mounted () {
        // 初始化内容
        this.getUserInfo();
    },
    methods: {
        //页面操作
        getUserInfo () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            if (token_cyw) {
                self.$get(`${baseUrl.sso}/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.code == 200) {
                        self.$router.push('/index')
                    }
                })
            }
        },

        /* 注册 */
        register (formName) {
            const self = this;
            self.$refs[formName].validate((valid) => {
                if (valid) {
                    // 判断手机号是否正确
                    if (!mw_validate.phone(self.registerForm.telephone)) {
                        self.$message({
                            message: '请输入正确的手机号',
                            type: 'warning'
                        });
                        return;
                    } else { // 验证成功后
                        // 进行验证码验证
                        self.registarLoading = true;
                        self.checkCode()
                    }
                    
                } else {
                    return false;
                }
            });
        },

        // 发送验证码
        sendCode () {
            const self = this;
            self.sendCodeTime = 60;
            let interval = setInterval(() => {
                if (self.sendCodeTime == 0) {
                    clearInterval(interval);
                } else {
                    if (self.sendCodeTime == 60) {
                        // 发送手机验证码
                        self.$get(`${baseUrl.sso}/api/sendCode?telephone=${self.registerForm.telephone}`, {}).then(res => {
                            if (res.code == 200) {
                                self.code = res.data;
                                this.$message('验证码已发送');
                            } else {
                                self.registarLoading = false;
                                self.$message.error(res.msg);
                                self.sendCodeTime = 0;
                            }
                        }).catch(err => {
                            self.registarLoading = false;
                            self.$message.error('验证码发送失败');
                            self.sendCodeTime = 0;
                        })
                    }
                    self.sendCodeTime--;
                }
            }, 1000)
        },

        // 验证验证码
        checkCode () {
            let self = this;
            // step1. 验证 验证码是否有效
            self.$get(`${baseUrl.sso}/api/checkCodeIsValid?telephone=${self.registerForm.telephone}`, {}).then(res => {
                if (res.code == 200) {
                    self.$postByX(`${baseUrl.sso}/api/checkCodeIsTrue?telephone=${self.registerForm.telephone}&code=${self.registerForm.code}`, {}).then(res_2 => {
                        if (res_2.code == 200) {
                            // 验证成功，提交数据
                            self.registerInfo();
                        } else {
                            self.registarLoading = false;
                            self.$message.error(res_2.msg);
                        }
                    })
                } else {
                    self.registarLoading = false;
                    self.$message.error(res.msg);
                }
            }) 
        },

        // 提交注册信息
        registerInfo () {
            let self = this;
            self.$postByX(`${baseUrl.business}/api/user/updatePwd?telephone=${self.registerForm.telephone}&newPwd=${self.registerForm.newPwd}`, {}).then(res => { // 保存后获取用户id
                if (res.status == 200) {
                    self.$confirm(`密码已修改, 去登录吧`, '提示', {
                        showClose: false,
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'success'
                    }).then(() => {
                        self.$router.push('/index')
                    })
                } else {
                    self.$message.error(res.msg)
                    self.registarLoading = false;
                }
            }).catch(err => {
                self.$message.error('修改失败')
            })
        },

    },
}
</script>

<style scoped>
    .login-code { border-right: 1px solid #f6f6f6; }
    .login-code img { width: 180px; }
    .login-code p { line-height: 26px; }
    .login-form, .top .login-code { padding: 40px; }
    .login-form .check-code .code-before { border: 1px solid #f6f6f6; height: 30px; line-height: 30px; width: 65px; position: relative; }
    .login-form .check-code .code-after { border: 1px solid #f6f6f6; border-radius: 5px; width: 65px; height: 30px; margin-left: 5px; margin-right: 5px;}
    .dialog-footer > div { height: 30px; line-height: 30px; }
</style>